import { getPhoneInformation as t } from "../api/services/index.js";
import { CSR_STATE as e } from "./index2.js";
import { createKnownQueryParametersProvider as n } from "../../../libraries/known_query_parameters/index.js";
import { KnownQueryKey as m } from "../../../libraries/known_query_parameters/index3.js";
const s = async () => {
  const o = n().provideParameter(
    m.CountryCode
  ) ?? "";
  e.switchContext({ countryCode: o }), t(o, !0).then((r) => {
    r.succeeded && e.set(r.result);
  });
};
export {
  s as loadPhoneInfo
};
//# sourceMappingURL=index.js.map
